export default __webpack_public_path__ + "static/media/props_ac.ae3ae7cd.png";